<div *ngIf="imgSrc" class="one-image-panel d-flex align-center flex-center" [ngStyle]="{'background-image': 'url(' + imgSrc + ')'}">
    <div class="one-image-panel__text plMd prMd">
        <ng-content></ng-content>
    </div>
</div>
